import { render, staticRenderFns } from "./TopicFormPanelReminder.vue?vue&type=template&id=28f6d7a6&lang=pug"
import script from "./TopicFormPanelReminder.vue?vue&type=script&lang=js"
export * from "./TopicFormPanelReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports